import { IconBulb, IconMapPins } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Timeline,
} from '#root/components/ui';
import styles from './styles.module.scss';

interface DeliverySetupDialogProps {
  open: boolean;
  onClose: () => void;
}

/** Cómo funcionan las Configuraciones de Entrega (pantalla "Configurar Entregas" del viajero). */
const DeliverySetupDialog = (props: DeliverySetupDialogProps) => {
  const { open = false, onClose } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader icon={<IconMapPins />} tone="info">
        <ModalTitle>Configurar Entregas</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Timeline
          variant="numbered"
          items={[
            'Crea una configuración de entrega con la información necesaria. (Puedes usar los textos predefinidos).',
            <>
              Al momento que marques un acuerdo como <strong>Listo para entregar</strong> podrás
              asociar esta información para que lo vea el comprador.
            </>,
            'Puedes usar la misma configuración de entrega para coordinar con uno, varios o todos los compradores que quieras. Tú decides a quién le das acceso.',
          ]}
        />
        <div className={styles.tips}>
          <h3 className={styles.heading}>
            <IconBulb size={18} aria-hidden="true" /> Consejos
          </h3>
          <ul>
            <li>
              Al crear una configuración, ponle un nombre de etiqueta como “Entrega en mi casa” o
              “Entrega en casa de Sofia” para que puedas identificarlos rápidamente luego.
            </li>
            <li>
              Por lo general, si siempre eres tú mismo quien viaja y entregas de la misma manera, no
              necesitas crear más que 1 configuración. Si es necesario, la puedes editar.
            </li>
            <li>
              Si has tenido una mala experiencia con un comprador y no quieres mostrarle ninguna
              configuración de entrega, simplemente no selecciones ninguna al momento de marcar su
              acuerdo como Listo para entregar, y contáctalo directamente para que coordinen otra
              alternativa.
            </li>
          </ul>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeliverySetupDialog;
